import * as React from 'react';
import { EventAttributes } from '@atlassiansox/analytics-web-client';
import LoadingButton, { LoadingButtonProps } from '@atlaskit/button/loading-button';
import { AnalyticsTag, sendSideBarButtonClickEvent } from '@atlassian/temp-analytics';
import { ufoCommonButtonClickEvents } from '@atlassian/temp-observability';
import { ENABLE_DESIGN_ITERATION_1 } from '@css-xp/ppc-constants';
import { useApplicationContext } from '../../../common-context';
import { useFeatureToggle, useSidebar } from '../../../hooks';
import { SidebarOptions } from '../../../state';

interface Props extends LoadingButtonProps {
  sidebar: string;
  sidebarOptions?: SidebarOptions;
  payload?: unknown;
  analyticsAttributes?: EventAttributes;
  analyticsTags?: AnalyticsTag[];
}

const OpenSidebarButton = ({ sidebar, sidebarOptions, payload, children, ...buttonProps }: Props) => {
  const { openSidebar, isSidebarOpen } = useSidebar();
  const context = useApplicationContext();
  const [isEnabled] = useFeatureToggle();
  const isDesignIteration1Enabled = isEnabled(ENABLE_DESIGN_ITERATION_1);

  const pageName = window.location.pathname.split('/')[1];
  const product = context.product?.toLowerCase();
  const label = buttonProps.label || 'sideBarButton';

  return !isSidebarOpen || isDesignIteration1Enabled ? (
    <LoadingButton
      {...buttonProps}
      onClick={() => {
        sendSideBarButtonClickEvent({
          sidebar,
        });
        ufoCommonButtonClickEvents(product, pageName, label);
        openSidebar({ sidebarType: sidebar, payload, sidebarOptions });
      }}
    >
      {children}
    </LoadingButton>
  ) : null;
};

export default OpenSidebarButton;
